import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';

interface ViewGoalDatesProps {
  startDate?: string;
  dueDate?: string;
}

export const ViewGoalDates: React.FC<ViewGoalDatesProps> = ({
  startDate,
  dueDate,
}) => {
  const { t } = useTranslation('goals');

  const formatDate = (dateString?: string) => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  if (!startDate && !dueDate) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      {startDate && (
        <div>
          <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-2">
            <Calendar className="h-3.5 w-3.5" />
            {t('startDateLabel')}
          </label>
          <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg">
            <span className="text-sm text-gray-700">
              {formatDate(startDate)}
            </span>
          </div>
        </div>
      )}
      {dueDate && (
        <div>
          <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-2">
            <Calendar className="h-3.5 w-3.5" />
            {t('dueDateLabel')}
          </label>
          <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg">
            <span className="text-sm text-gray-700">{formatDate(dueDate)}</span>
          </div>
        </div>
      )}
    </div>
  );
};
